import { Field } from '@sitecore-jss/sitecore-jss-nextjs';
import {
  FormFieldCheckbox as FormFieldCheckboxProps,
  FormFieldCheckboxes as FormFieldCheckboxesProps,
  FormFieldDatePicker as FormFieldDatePickerProps,
  FormFieldDropdown as FormFieldDropdownProps,
  FormFieldPhone as FormFieldPhoneProps,
  FormFieldRadio as FormFieldRadioProps,
  FormFieldRecaptcha as FormFieldRecaptchaProps,
  FormFieldText as FormFieldTextProps,
  FormFieldTextArea as FormFieldTextAreaProps,
  FormFieldType,
} from '../../../component-props';
import { FormFieldProps } from './FormTypes';
import { FormFieldCheckbox } from '../fields/FormFieldCheckbox/FormFieldCheckbox';
import { FormFieldCheckboxes } from '../fields/FormFieldCheckboxes/FormFieldCheckboxes';
import { FormFieldDatePicker } from '../fields/FormFieldDatePicker/FormFieldDatePicker';
import { FormFieldDropdown } from '../fields/FormFieldDropdown/FormFieldDropdown';
import { FormFieldPhone } from '../fields/FormFieldPhone/FormFieldPhone';
import { FormFieldRadio } from '../fields/FormFieldRadio/FormFieldRadio';
import { FormFieldRecaptcha } from '../fields/FormFieldRecaptcha/FormFieldRecaptcha';
import { FormFieldText } from '../fields/FormFieldText/FormFieldText';
import { FormFieldTextArea } from '../fields/FormFieldTextArea/FormFieldTextArea';

export const buildField = ({
  field,
  fieldRefs,
  formSilent,
}: { field: FormFieldType } & FormFieldProps): JSX.Element => {
  const fieldType = field.fields.fieldType as Field<string>;
  if (fieldType?.value) {
    switch (fieldType.value) {
      case 'checkbox':
        return (
          <FormFieldCheckbox
            key={field.id}
            fieldRefs={fieldRefs}
            formSilent={formSilent}
            {...(field as FormFieldCheckboxProps)}
          />
        );
      case 'checkboxes':
        return (
          <FormFieldCheckboxes
            key={field.id}
            fieldRefs={fieldRefs}
            formSilent={formSilent}
            {...(field as FormFieldCheckboxesProps)}
          />
        );
      case 'datePicker':
        return (
          <FormFieldDatePicker
            key={field.id}
            fieldRefs={fieldRefs}
            formSilent={formSilent}
            {...(field as FormFieldDatePickerProps)}
          />
        );
      case 'dropdown':
        return (
          <FormFieldDropdown
            fieldRefs={fieldRefs}
            formSilent={formSilent}
            {...(field as FormFieldDropdownProps)}
          />
        );
      case 'phone':
        return (
          <FormFieldPhone
            key={field.id}
            fieldRefs={fieldRefs}
            formSilent={formSilent}
            {...(field as FormFieldPhoneProps)}
          />
        );
      case 'radio':
        return (
          <FormFieldRadio
            key={field.id}
            fieldRefs={fieldRefs}
            formSilent={formSilent}
            {...(field as FormFieldRadioProps)}
          />
        );
      case 'recaptcha':
        return (
          <FormFieldRecaptcha
            key={field.id}
            fieldRefs={fieldRefs}
            formSilent={formSilent}
            {...(field as FormFieldRecaptchaProps)}
          />
        );
      case 'text':
        return (
          <FormFieldText
            key={field.id}
            fieldRefs={fieldRefs}
            formSilent={formSilent}
            {...(field as FormFieldTextProps)}
          />
        );
      case 'textArea':
        return (
          <FormFieldTextArea
            key={field.id}
            fieldRefs={fieldRefs}
            formSilent={formSilent}
            {...(field as FormFieldTextAreaProps)}
          />
        );
    }
  }
  return <></>;
};
